import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=541604d2&scoped=true&"
import script from "./GoodsList.vue?vue&type=script&lang=ts&"
export * from "./GoodsList.vue?vue&type=script&lang=ts&"
import style0 from "./GoodsList.vue?vue&type=style&index=0&id=541604d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541604d2",
  null
  
)

export default component.exports